export default {
  props: {
    title: {
      type: String,
      required: true,
    },

    body: {
      type: String,
      default: '',
    },

    buttons: {
      type: [Array, Object],
    },

    appStoreButtons: {
      type: [Array, Object],
    },
  },
}
